var backColor = ['#FFF9E9','#FFFFFF','#FEF5EE','#FFF9E9','#FFFFFF','#FEF5EE','#FFF9E9','#FFFFFF','#FEF5EE']
import _ from 'loadsh'
export default {
	props: {
		comData: {
			type: Object,
			default() {
				return {}
			}
		},
		isEdit: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		isPreview() {
      return this.$route.query.isPreview == 1;
    },
	},
	watch: {
    comData: {
      handler(newVal,oldVal) {
        this.init()
      },
      deep: true,
      immediate: true
    },
  },
	data() {
		return {
			icon: {
				award: 'https://img3.quanyou.com.cn/joy/group1/M00/12/E2/rB4ChmLDxqmAYJvZAAEvcPvvtpk527.png',
				redPack: 'https://img3.quanyou.com.cn/joy/group1/M00/12/4A/rB4ChmKyfwiAHzc3AAB6CftVG-w982.png',
				thanks: 'https://img3.quanyou.com.cn/joy/group1/M00/12/E2/rB4ChmLDx9GAIPM2AADCTPE8P0U714.png'
			},
			acitveIndex: -1,
			prizePool: [],
			cloneComdata: {},
			blocks: [{ 
        padding: '40px',
        imgs:[{ 
          src: 'https://img3.quanyou.com.cn/joyNew/group1/M00/0B/CE/rB8LrmRbQLOAGsAhAAKOVwXFodo885.png',
          width: '375px',
          height: '375px',
          top: '-8px'
        }]
      }],
      buttons: [
        { radius: '37px' },
        { imgs:[{
            src: 'https://img3.quanyou.com.cn/joyNew/group1/M00/19/26/rB8LrWUCyGaAJ14IAAAv3YwRQSk225.png',
            width: '87px',
            height: '89px',
            top: '-55px'
          }]
        }
      ],
		}
	},
	methods: {
		init() {
			this.cloneComdata = _.cloneDeep(this.comData)
			this.prizePool = this.formatPrizeData(this.cloneComdata)
			this.prizePool.forEach((item,index) => {
				item.background = backColor[index]
			})
		},
		formatPrizeData(data) {
			let prizePool = []
			data.prizeList.push({ awardType: 'thanks', awardName:'谢谢参与',bakImg:[]})
			data.prizeList.forEach((item) => {
				prizePool.push({ 
					fonts: [{ 
						text: item.awardType === 'redPack' ? item.singleAmount + '元现金红包' : item.awardName, 
						top: '10%',
						fontSize: '10px',
						fontColor: '#C55C2E',
						top: '46px',
					}], 
					imgs: [{
						src: item.bakImg.length != 0 ? item.bakImg[0].url : this.icon[item.awardType],
						width: '40px',
						height: '40px',
						top: '5px'
					}],
				})
			});
			let i = 0
			let recursion = (prizePool) => {
				if (prizePool.length < 9) {
					prizePool.push(prizePool[i])
					i++
					recursion(prizePool)
				}
			}
			recursion(prizePool)
			return prizePool
		},
	}
};